export default __webpack_public_path__ + "static/mid2-0aaa5da29431f5e04dc91485cc854dee.png";